import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const CartPdfView = () => {
    const { email: emailFromUrl } = useParams<{ email?: string }>();
    const navigate = useNavigate();

    const [cartData, setCartData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadCart = async () => {
            setIsLoading(true);

            // Only use email from URL
            if (!emailFromUrl) {
                console.error("Email not provided in URL");
                setIsLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}font-end/cart-data-public`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ email: emailFromUrl }),
                    }
                );

                const result = await response.json();

                if (response.ok && result.statusCode === 200 && result.data?.cart?.length > 0) {
                    setCartData(result.data.cart[0]);
                } else {
                    console.warn("No cart data found for this email");
                    setCartData(null);
                }
            } catch (err) {
                console.error("Cart PDF Public API Error:", err);
                setCartData(null);
            } finally {
                setIsLoading(false);
            }
        };

        loadCart();
    }, [emailFromUrl]);

    if (isLoading) {
        return <div style={{ padding: 20 }}>Loading cart data...</div>;
    }

    if (!cartData) {
        return <div style={{ padding: 20 }}>No cart data found for this user.</div>;
    }

    return (
        <div
            style={{
                padding: "30px",
                fontFamily: "'Segoe UI', Arial, sans-serif",
                maxWidth: "900px",
                margin: "0 auto",
                background: "#fff",
                border: "1px solid #ddd",
                borderRadius: "10px",
            }}
        >
            {/* Header */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "2px solid #eee",
                    paddingBottom: "15px",
                    marginBottom: "25px",
                }}
            >
                <h1 style={{ margin: 0, fontSize: "28px", color: "#4d2f5d" }}>
                    Customer Cart Summary
                </h1>
                <p style={{ marginTop: "5px", color: "#888" }}>
                    Generated on {new Date().toLocaleDateString()}
                </p>
            </div>

            {/* Customer Info */}
            <div className="border border-black bg-[#eeecef] p-3 rounded-xl mt-7">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    <div>
                        <p className="text-sm font-medium text-black mb-1">Name:</p>
                        <p className="text-sm font-medium text-black">
                            {cartData.first_name}
                        </p>
                    </div>

                    <div>
                        <p className="text-sm font-medium text-black mb-1">Email:</p>
                        <p className="text-sm font-medium text-black">
                            {cartData.email}
                        </p>
                    </div>

                    <div>
                        <p className="text-sm font-medium text-black mb-1">
                            Total Products:
                        </p>
                        <p className="text-sm font-medium text-black">
                            {cartData.detailed_codes?.length}
                        </p>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="mt-4 sm:mt-6 overflow-x-auto">
                <div className="rounded-t-3xl rounded-l-3xl min-w-[640px]">
                    <table className="w-full border-collapse">
                        <thead className="bg-[#5e4666] text-white rounded-t-3xl">
                            <tr>
                                <th className="border border-gray-300 p-3 text-center">Code</th>
                                <th className="border border-gray-300 p-3 text-center">Name</th>
                                <th className="border border-gray-300 p-3 text-center">Price</th>
                                <th className="border border-gray-300 p-3 text-center">Qty</th>
                                <th className="border border-gray-300 p-3 text-center">Discount</th>
                                <th className="border border-gray-300 p-3 text-center">Taxes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cartData.detailed_codes?.map((p: any, i: number) => (
                                <tr key={i}>
                                    <td className="border border-gray-300 p-3 text-center">{p.code}</td>
                                    <td className="border border-gray-300 p-3 text-center">{p.name}</td>
                                    <td className="border border-gray-300 p-3 text-center">₹ {p.price}</td>
                                    <td className="border border-gray-300 p-3 text-center">{p.quantity || 1}</td>
                                    <td className="border border-gray-300 p-3 text-center">{p.discount || 0}</td>
                                    <td className="border border-gray-300 p-3 text-center">{p.GST}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Footer */}
            <footer
                style={{
                    textAlign: "center",
                    marginTop: "40px",
                    paddingTop: "15px",
                    borderTop: "1px solid #eee",
                    color: "#777",
                    fontSize: "14px",
                }}
            >
                © {new Date().getFullYear()} Vijaydeep – All Rights Reserved
            </footer>
        </div>
    );
};

export default CartPdfView;
